export default "/static/images/roof_1.png?7fabedf6e1399e609d7c2503d887dab1";